export default "__VITE_ASSET__H17tDgBC__"